import { render, staticRenderFns } from "./Ipc.vue?vue&type=template&id=15cb6e5a&"
import script from "./Ipc.vue?vue&type=script&lang=ts&"
export * from "./Ipc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports